//interfaces
import { IPasskeyResetNotification} from "@/interfaces/activityFeedNotifications";
import { UserActivity } from "@/interfaces/activityFeed";

//components
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import ContentTitle from "../../elements/contentTitle/ContentTitle";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import PasskeyResetTitle from "../../elements/notificationTitle/PasskeyResetTitle/PasskeyResetTitle";

//hooks
import { usePasskeysReset } from "./PasskeysReset.hooks";

//styling
import "../../../../../css/activityFeed/notifications/passkeys-reset-activity.scss";


const PasskeysReset = ({zIndexNum, isPopOut = false, timeStamp, dateStamp, user, client, userPageLink, message}: IPasskeyResetNotification) => {
    const {screenClassName, activityInfo, userMessage} = usePasskeysReset({isPopOut, timeStamp, dateStamp, client, message});

    return (
        <div className={`${isPopOut ? "" : "passkeys-reset-full"} passkeys-reset notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.accountRecoveryRequest} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <PasskeyResetTitle 
                    user={user.name} 
                    isPopOut={isPopOut}
                />
            </div>        

            <ContentTitle 
                isItalic={!message}
                zIndexNum={zIndexNum} 
                className={screenClassName} 
                contentTitle={userMessage} 
                userPageLink={userPageLink}
                showMenu
            />

            <ActivityInformationPanel 
                {...activityInfo} 
            />
        </div>
    )
};

export default PasskeysReset